import React from "react";
import ReactModal from "react-modal";

interface IInfoModalProps {
  buttonText: string;
  contentStyles?: React.CSSProperties | undefined;
  footerText?: string;
  handleButtonClick: VoidFunction;
  headerText: string;
  listContent?: string[];
  listHeaderText?: string;
  mainText: string;
  overlayStyles?: React.CSSProperties | undefined;
  showModal: boolean;
}

export function InfoModal({
  buttonText,
  contentStyles,
  footerText,
  handleButtonClick,
  headerText,
  listContent,
  listHeaderText,
  mainText,
  overlayStyles,
  showModal
}: IInfoModalProps) {
  ReactModal.setAppElement("body");

  return (
    <ReactModal
      isOpen={showModal}
      className="info-modal ch-bg--white ch-pa--4"
      style={{
        overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)", ...overlayStyles },
        content: {
          position: "absolute",
          left: "50%",
          top: "30%",
          transform: "translate(-50%, -30%)",
          borderRadius: "4px",
          outline: "none",
          padding: "20px",
          ...contentStyles
        }
      }}
    >
      <p className="ch-fs--3 modal-close" onClick={handleButtonClick}>
        {buttonText}
      </p>

      <p className="ch-fs--3  modal-header">{headerText}</p>
      <p>{mainText}</p>
      {listHeaderText && <p className="modal-text">{listHeaderText}</p>}
      {listContent && (
        <ul className="ch-mb--2 ch-list">
          {listContent.map((listItem) => (
            <li key={listItem}>{listItem}</li>
          ))}
        </ul>
      )}
      {footerText && <p className="modal-text">{footerText}</p>}
    </ReactModal>
  );
}
